import { render, staticRenderFns } from "./activityReferenceShiftDetails.html?vue&type=template&id=154bc0cb&scoped=true&external"
import script from "./activityReferenceShiftDetails.vue?vue&type=script&lang=js"
export * from "./activityReferenceShiftDetails.vue?vue&type=script&lang=js"
import style0 from "./activityReferenceShiftDetails.css?vue&type=style&index=0&id=154bc0cb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154bc0cb",
  null
  
)

export default component.exports